module.exports = __webpack_public_path__ + "img/cmm.3e76537d.svg";